module.exports = __webpack_public_path__ + "img/class5.eb0bfccf.webp";